export default "__VITE_ASSET__CzG4ZsXM__"